import { render, staticRenderFns } from "./ProcessingOrders.vue?vue&type=template&id=530eb66c&scoped=true"
import script from "./ProcessingOrders.vue?vue&type=script&lang=js"
export * from "./ProcessingOrders.vue?vue&type=script&lang=js"
import style0 from "./ProcessingOrders.vue?vue&type=style&index=0&id=530eb66c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_f8be560a05ba39e4779a4b3800f88bf1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530eb66c",
  null
  
)

export default component.exports